import configJson from "./auth_config.json";

export function getConfig() {
  return {
    domain: configJson.domain,
    clientId: configJson.clientId,
    audience: configJson.audience
  };
}

export function getAPIUrl() {
  return configJson.apiUrl
}

export function getUserInterfaceUrl() {
  return configJson.userInterfaceUrl
}

export function getSupabaseStorageBucket() {
  return configJson.supabaseStorageBucket ?? "items"
}

export function getQRCodePath() {
  return configJson.qrCodePath
}

export function generateQRCodeUrl(qrCode) {
  return `${getUserInterfaceUrl()}${getQRCodePath()}${qrCode}`
}
